import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DatePickerUtils from '@sprinx/date-picker-utils/DateFnsUtils';
import MuiFieldsContext from '../MuiFieldsContext';

function MuiFieldsProvider(_ref) {
  var children = _ref.children,
      currencyDecimalPrecision = _ref.currencyDecimalPrecision,
      currencyDefault = _ref.currencyDefault,
      currencyFormat = _ref.currencyFormat,
      currencyTypes = _ref.currencyTypes,
      numberDecimalPrecision = _ref.numberDecimalPrecision,
      percentDecimalPrecision = _ref.percentDecimalPrecision,
      supportedLanguages = _ref.supportedLanguages,
      users = _ref.users;

  var _useState = useState({
    currencyDecimalPrecision: currencyDecimalPrecision,
    currencyDefault: currencyDefault,
    currencyFormat: currencyFormat,
    currencyTypes: currencyTypes,
    numberDecimalPrecision: numberDecimalPrecision,
    percentDecimalPrecision: percentDecimalPrecision,
    supportedLanguages: supportedLanguages,
    users: users
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var updateSettings = function updateSettings() {
    var nextSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setState(function (ps) {
      return _extends({}, ps, {}, nextSettings);
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: DatePickerUtils
  }, /*#__PURE__*/React.createElement(MuiFieldsContext.Provider, {
    value: _extends({}, state, {
      updateSettings: updateSettings
    })
  }, children)));
}

MuiFieldsProvider.propTypes = {
  children: PropTypes.node,

  /**
   * Cislo identifikujici pocet desetinnych mist pro hodnoty typu mena.
   */
  currencyDecimalPrecision: PropTypes.number,

  /**
   * ISO kod (3 znaky) identifikujici defaultni menu.
   */
  currencyDefault: PropTypes.string,

  /**
   * Format zobrazeni meny.
   * - 'accounting' -> XXX Kč
   * - 'code' -> XXX CZK
   */
  currencyFormat: PropTypes.oneOf(['accounting', 'code']),
  currencyTypes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])),

  /**
   * Cislo identifikujici pocet desetinnych mist pro hodnoty typu cislo.
   */
  numberDecimalPrecision: PropTypes.number,

  /**
   * Cislo identifikujici pocet desetinnych mist pro hodnoty typu procento.
   */
  percentDecimalPrecision: PropTypes.number,
  supportedLanguages: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    code: PropTypes.string.isRequired
  }), PropTypes.string])),
  users: PropTypes.shape({
    search: PropTypes.func,
    types: PropTypes.arrayOf(PropTypes.object)
  })
};
MuiFieldsProvider.defaultProps = {
  children: null,
  currencyDecimalPrecision: 2,
  currencyDefault: 'EUR',
  currencyFormat: 'accounting',
  currencyTypes: ['EUR'],
  numberDecimalPrecision: 2,
  percentDecimalPrecision: 0,
  supportedLanguages: ['en'],
  users: {}
};
export default MuiFieldsProvider;